import styled from 'styled-components'

export const GridWrapper = styled.div`
  display: flex;
  margin: 0 auto;
  flex-wrap: wrap;
  gap: 1%;
  padding: 0;
  justify-content: flex-start;
  margin-right: -1%;

  .card-grid {
    width: 24%;
    margin-bottom: 1%;
    justify-self: center;

    a {
      margin-right: 0;
    }
  }

  @media (max-width: 768px) {
    .card-grid {
      width: 49%;
      margin-bottom: 1%;
    }
  }

  @media (max-width: 480px) {
    .card-grid {
      gap: 0;
      width: 100%;
      margin-bottom: 15px;
      margin-right: 0;
    }
  }
`
